import styled from "styled-components";
import { Paper, Modal } from "@mui/material";
import { Dialog, Fab } from "@mui/material";
import { deviceSpec } from "breakpoints";
import Markdown from "markdown-to-jsx";

export const ChatModalDiv = styled("div")``;

export const ChatHeader = styled("div")({});

export const LiveChatDiv = styled("div")({});

export const LiveChatText = styled("text")({});

export const ChatInnerDiv = styled("div")({});

export const IconDiv = styled("div")({});

export const ChatText = styled("text")({});

export const AccentureIconDiv = styled("div")({});

export const ChatTitle = styled("text")({});

export const CloseDiv = styled("div")({});

//------------------------------------
// Messages/index.tsx
//------------------------------------
export const ChatBotFeedbackStyle = styled("div")`
  display: flex;
  cursor: pointer;
  align-items: center;
  padding: 0.25em 0;

  .MuiSvgIcon-root {
    color: ${({ theme }) => theme.colors.textColor};
  }

  .done {
    color: ${({ theme }) => theme.colors.light};
  }
`;

export const FullHistoryButton = styled("button")`
  background-color: ${({ theme }) => theme.colors.fullhistoryitemsbg} !important;
`;

export const MessageTextPaper = styled(Paper)`
  padding: 0.5rem 0.75rem;
  margin-right: 0.5rem;
  z-index: 2;
  white-space: pre-wrap;
`;

export const MessageTextDiv = styled("div")`
  // padding: 0.5rem;
  // z-index: 2;
  // white-space: pre-wrap;
`;

export const MessageTime = styled("p")`
  color: ${({theme}) => theme.colors.textColor};
`;

export const MessageWidgetDiv = styled("div")`
  padding: 0.75rem 0;
  z-index: 2;
`;

export const MessageRowContentSpan = styled("span")`
  display: flex;
  align-items: center;
  z-index: 1;

  .pointer-right,
  .pointer-left {
    height: 20px;
    width: 20px;
    transform: rotate(45deg);
    position: relative;
    margin: 0 !important;
    box-shadow: none;
  }

  .pointer-right {
    right: 10px;
    margin-right: 1rem;
    border-radius: 0 6px 0 0;
  }

  .pointer-left {
    left: 10px;
    margin-left: 1rem;
    border-radius: 0 0 0 6px;
  }

  @media ${deviceSpec.isMobile} {
    canvas {
      display: none;
    }
  }
`;

export const MessageContainerDiv = styled("div")`
  display: flex;
  max-width: 100%;
  align-items: flex-start;
  flex-direction: column;
  border-radius: 10px;
  padding: 20px;
  // color: white;
`;

export const MessageTextHuman = styled("p")`
  font-weight: 400;
  white-space: pre-wrap;
  color: black;
`;

export const MessageTextAI = styled(Markdown)`
  fontsize: ${({ theme }) => theme.font.medium};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textColor};
`;

// Like/Dislike Feedback Modal
export const ChatBotTextAreaDiv = styled("div")({
  width: "500px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const BootstrapDialog = styled(Modal)`
  // display: flex;
  // justify-content: center;
  // align-content: center;

  border-radius: 1rem;

  textarea:focus {
    outline: none !important;
    border: 1px solid red;
    border: 1px solid #6d9faf;
  }

  textarea:focus-visible {
    outline: none !important;
    border: 1px solid red;
    border: 1px solid #6d9faf;
  }
`;

export const BootstrapDialogInnerContainer = styled(Paper)`
  width: max-content;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 25rem;
  box-shadow: 0 1px 1px hsl(0deg 0% 0% / 0.075), 0 2px 2px hsl(0deg 0% 0% / 0.075), 0 4px 4px hsl(0deg 0% 0% / 0.075), 0 8px 8px hsl(0deg 0% 0% / 0.075), 0 16px 16px hsl(0deg 0% 0% / 0.075);
  
  .primary-color-btn {
    background-color: ${({ theme }) => theme.colors.light};
    color: ${({ theme }) => theme.colors.textColor};
  }

  border-radius: 12px;

  @media (${deviceSpec.isMobile}) {
    width: 85%;
  }

  @media (min-width: 576px) {
    .modal-dialog {
      margin-right: auto;
      margin-left: auto;
    }
  }

  .MuiAutocomplete-root {
    input {
      border: none;
    }
  }

  textarea,
  input,
  select,
  textarea:active,
  input:active,
  select:active {
    background-color: transparent !important;
    border: 1px solid ${({ theme }) => theme.colors.buttonBorder};
    padding: 0.375rem 0.75rem;
    color: ${({ theme }) => theme.colors.textColor};
  }

  .MuiPaper-root {
    border-radius: 0 0 1rem 1rem;
    display: flex;
    justify-content: end;
  }
`;

export const ChatBotTextArea = styled("textarea")`
  border: 1px solid rgb(60, 63, 67);
  padding: 0.375rem 0.75rem;
  background-color: transparent !important;
  width: 100%;
  min-height: 150px;
  border-radius: 0.5rem;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.5);
`;

export const ChatBotTextInput = styled("input")`
  border: 1px solid rgb(60, 63, 67);
  padding: 0.375rem 0.75rem;
  background-color: transparent !important;
  width: 100%;
  border-radius: 0.5rem;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.5);
`;

export const DialogActionsButtonContainer = styled("div")`
  display: flex;
  justify-content: end;
  padding: 1.25rem 1.25rem;

  button {
    border-top: ${({ theme }) => theme.borders.headerBorder} !important;
    background-color: ${({ theme }) => theme.colors.light} !important;
    color: white !important;
  }
`;

export const InnerDiv = styled("div")({
  width: "500px",
});

export const FeedbackTextP = styled("p")({
  fontWeight: "600",
  fontSize: "26px",
  textAlign: "center",
});

//------------------------------------
// UserInput/index.tsx
//------------------------------------
export const ChatContainer = styled("div")<{ headerheight: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  display: grid;
  grid-template-columns: auto 1fr;

  // The theme cannot affect this page
  p, li, span, strong, a, h1, h2, h3, h4, h5, h6 {
    color: ${({ theme }) => theme.colors.textColor};
  }

  // fill available height from parent flex container
  height: 100%;
  flex: 1;
  overflow: hidden;

  .wave {
    position: relative;
    text-align: center;
    margin-left: auto;
    margin-right: auto;

    .dot {
      color: ${({theme}) => theme.colors.textColor};
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 3px;
      background: ${({theme}) => theme.colors.textColor};
      animation: wave 1.3s linear infinite;

      &:nth-child(2) {
        animation-delay: -1.1s;
      }

      &:nth-child(3) {
        animation-delay: -0.9s;
      }
    }
  }

  @keyframes wave {
    0%,
    60%,
    100% {
      transform: initial;
    }

    30% {
      transform: translateY(-10px);
    }
  }
`;

export const HistoryBody = styled("div")<{ ismenuopen: string }>`
  width: ${({ ismenuopen }) => (ismenuopen === "true" ? "300px" : "47px")};
  white-space: pre;
  // overflow-y: auto;
  overflow-y: hidden;
  height: 100%;

  box-shadow: ${({ theme }) => theme.shadows.boxShadow};
  z-index: 5;

  background-color: ${({ theme }) => theme.colors.historyBg};

  .hide-on-short-menu {
    display: ${({ ismenuopen }) => (ismenuopen === "true" ? "flex" : "none")};
  }

  h3 {
    font-size: 0.9rem;
    line-height: 1.5rem;
    font-weight: 500;
    height: 24px;
    display: flex;
    align-items: center;
  }

  .MuiButtonBase-root {
    width: fit-content;
    min-width: fit-content;
    padding: 0 !important;
  }

  .chat-title-banner {
    position: sticky;
    top: 0;
    background-color: ${({ theme }) => theme.colors.mediumGrey};
    padding: 1rem;
    z-index: 1;
  }


  .loading {
    -webkit-animation: spin 0.5s linear infinite;
    -moz-animation: spin 0.5s linear infinite;
    animation: spin 0.5s linear infinite;

    @-moz-keyframes spin {
      100% {
        -moz-transform: rotate(360deg);
      }
    }
    @-webkit-keyframes spin {
      100% {
        -webkit-transform: rotate(360deg);
      }
    }
    @keyframes spin {
      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
  }

  .round {
    border-radius: 100%;
    width: 24px;
    height: 24px !important;
    min-width: 24px;
    padding: 0;
    border-radius: 100%;
    // color: white;
  }

  .dot {
    color: ${({theme}) => theme.colors.textColor};
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 3px;
    background: ${({theme}) => theme.colors.textColor};
  }

  .dot-container {
    display: flex;
    flex-direction: row;
  }

  .dot-container:hover {
    .dot {
      background: white;
    }
  }
`;

export const HistoryItem = styled("div")<{ isselected: string}>`
  margin: 0.125rem 0;
  background-color: ${({ isselected, theme }) => isselected === "true" ? theme.colors.historyItemselect : "inherit" };

  .highlight-dots {
    .dot {
      background: white;
    }
  }
`;

export const SectionHeader = styled("div")`
  position: sticky;
  top: 0;
  background-color: ${({ theme }) => theme.colors.historyBg};
  z-index: 10;
  padding: 0.5rem;
  border-radius: ${({ theme }) => theme.borders.borderRadius};
  
  &:hover {
    background-color: ${({ theme }) => theme.colors.historyItemhvr};
  }
`;

export const HistoryItemStyledMenuContainer = styled("div")`
  background-color: ${({ theme }) => theme.colors.historyBg};

  > div:hover {
    background-color: ${({ theme }) => theme.colors.historyItemhvr};
  }
`

export const HistoryItemsHeader = styled("div")`
`;

export const HistoryItemsContainer = styled("div")`
  > div:hover {
    background-color: ${({ theme }) => theme.colors.historyItemhvr};
  }

  > div,
  > h3 {
    padding: 0.5rem 0.5rem 0.5rem 0.75rem;
    color: ${({ theme }) => theme.colors.textColor};
    border-radius: ${({ theme }) => theme.borders.borderRadius};
  }
`;

export const ChatBody = styled("div")<{ ismenuopen: string }>`
  overflow-y: auto;
  height: 100%;

  .chat-message-container-modal {
    position: sticky;
    width: max-content;
    margin: 1em;
  }

  .chat-title-banner-open {
    display: ${({ ismenuopen }) =>
      ismenuopen === "true" ? "none" : "initial"};
    position: sticky;
    width: max-content;
    margin: 0.5rem;
  }

  .MuiButtonBase-root {
    width: fit-content;
    min-width: fit-content;
    height: max-content;
  }
`;

export const UserInputWrapperDiv = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 4;
  padding: 3rem 2rem 3rem;
  background-image: ${({ theme }) =>
  theme.name === 'dark-theme'
    ? 'linear-gradient(to bottom, transparent 0%, #1c2128 20%)'
    : `linear-gradient(to bottom, transparent 0%, ${theme.colors.white} 20%)`};

  padding: 3rem 2rem 3rem 2rem;

  fieldset {
    border: none;
  }

  .MuiButtonBase-root {
    padding: 0.5rem;
    margin: 0;
    border-radius: 5px;
  }
`;

export const HistorySelectedCount = styled('p')`
  color: ${({theme}) => theme.colors.highlight6 };
`

export const RightPreview = styled('div')`
  background-color: ${({ theme }) => theme.colors.rightpreview};
  span{
    color: ${({theme}) => theme.colors.textColor};
  }
  pre{
    background-color: ${({ theme }) => theme.colors.rightpreview};
    color: ${({theme}) => theme.colors.textColor};
  }
`

export const UserInputWrapperDivBackground = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 3;
  padding: 2em 2em 2em 2em;
  height: 175px;
  width: 100%;
  background-color: #1d1d1d;
`;

export const ChatBodyInnerContainer = styled("div")`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .flex-grow-1 {
    flex-grow: 1;
  }

  .message {
    margin: 15px 0;
    padding: 10px;
  }

  .justify-self-end {
    justify-self: end;
  }

  .justify-self-start {
    justify-self: start;
  }

  .ai {
    align-self: flex-start;
    border-radius: 20px 20px 20px 0;

    .extra-space-below {
      margin-bottom: 10px;
    }
  }

  .user {
    align-self: flex-end;
    color: #fff;
    border-radius: 20px 20px 0 20px;
  }

  .transition-column {
    transition: width 0.5s ease-in-out;
  }

  .screen-adjustable-width {
    width: 66.66667%;

    @media ${deviceSpec.isLaptop} {
      width: 80%;
    }

    @media ${deviceSpec.isMobile} {
      width: 100%;
    }
  }
`;

export const MessagesContentContainer = styled("div")`
  width: 100%;
`;

export const ChatNavButtons = styled("div")`
  display: flex;
  flex-direction: row;
  width: max-content;
  width: 100%;
  position: sticky;
  top: 0;
  background-color: #232833;

  height: fit-content;

  input {
    width: 100% !important;
  }
`;
export const UserInputContainer = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div:nth-child(2) {
    align-self: center;
  }

  p {
    font-size: initial;
  }

  .shimmer-box {
    width: auto;
    max-width: max-content;
    padding: 1rem;
  }

  button:is(:hover, :focus-visible) {
    --active: 0.5;
  }
`;

// bg-gray-200/10 p-6 rounded-xl w-full mb-4 shadow-lg transition-all duration-300 ease-in-out block

export const FullHistoryContainer = styled("div")`
  display: grid;
  grid-template-rows: 185px 1fr;
  grid-template-columns: 1fr;
  justify-items: center;
  align-items: center;
  overflow: hidden;
`;

export const CustomCheckBoxStyle = styled("div")`
  position: absolute;
  left: -0.75rem;

  > div:hover {
    border: 1px solid ${({ theme }) => theme.colors.textColor};
  }

  > div {
   border: ${({ theme }) => theme.name === "dark-theme" ? `1px solid rgb(70, 70, 70)` : `1px solid rgb(70, 70, 70)`};
`;

export const CustomHistoryModalContainer = styled(Modal)`
  .modal-container {
    background-color: ${({theme}) => theme.colors.historyBg};

    p, span {
      color: ${({theme}) => theme.colors.textColor};
    }
  }
`;

// specialCases/Language.tsx
export const LanguageTranslationContainer = styled('div')`
  ${({theme}) => theme.name === "light-theme" && (
    `
      background-color: ${theme.colors.tagBtnBg};
      background-image: none !important;
      border: none !important;
    `
  )};
`